module.exports = __webpack_public_path__ + "img/jmbg.024a01fd.jpg";